import { translate } from "app/filters/i18nFilter";
import {
    StyledAutoCreatedTagSmall,
    StyledAutoCreatedTag,
    StyledAutoCreatedIcon,
    StyledAutoCreatedText,
} from "./styles";

const AutoCreatedTag = ({ isSmall, className }: { isSmall?: boolean; className?: string }) => (
    <>
        {isSmall ? (
            <StyledAutoCreatedTagSmall className={className}>
                <StyledAutoCreatedIcon iconName="similar-icon" />
            </StyledAutoCreatedTagSmall>
        ) : (
            <StyledAutoCreatedTag className={className}>
                <StyledAutoCreatedIcon iconName="similar-icon" />
                <StyledAutoCreatedText>{translate("si.opportunity-list.auto-created.tag")}</StyledAutoCreatedText>
            </StyledAutoCreatedTag>
        )}
    </>
);

export default AutoCreatedTag;
